import Dexie from 'dexie';
import 'dexie-observable';

export class LinesideDatabase extends Dexie {
    userSites: Dexie.Table<IUserSite, number>;
    savedUserSites: Dexie.Table<ISavedUserSite, number>;
    sites: Dexie.Table<ISite, number>;
    blocks: Dexie.Table<IBlock, number>;
    other: Dexie.Table<IOther, number>;
    images: Dexie.Table<IImage, number>;
    constructor () {
        super("LinesideDatabase");
        this.version(1).stores({
            userSites: `userSiteId, siteId, route, name, elr, mileage, latitude, longitude, status, username, lastModified, created`,
            savedUserSites: `userSiteId, siteId, route, name, elr, mileage, latitude, longitude, status, lastModified, created`,
            sites: `siteId, route, name, altName, operationalStatus, elr, mileage, latitude, longitude, status, lastModified, created`,
            blocks: `blockId, name, altName, operationalStatus, elr, mileage, siteId, lastModified, created`,
            other: `++id`,
            images: `++id`
        })
        this.userSites = this.table("userSites");
        this.savedUserSites = this.table("savedUserSites");
        this.sites = this.table("sites");
        this.blocks = this.table("blocks");
        this.other = this.table("other");
        this.images = this.table("images");
    }
}

export interface IUserSite {
    userSiteId: number,
    siteId: number,
    route: string,
    name: string,
    altName: string,
    operationalStatus: string,
    siteType: string, 
    address: string, 
    postcode: string,  
    elr: number,
    mileage: number,
    latitude: number,
    longitude: number,
    photos: string[] | null,
    comments: string,
    status: string,
    username: string,
    lastModified: number,
    created: number
}

export interface ISavedUserSite {
    userSiteId?: number,
    siteId: number,
    route: string,
    name: string,
    altName: string,
    operationalStatus: string,
    siteType: string, 
    address: string, 
    postcode: string,  
    elr: number,
    mileage: number,
    latitude: number,
    longitude: number,
    photos: string[] | null,
    comments: string,
}

export interface ISite {
    siteId: number,
    route: string,
    name: string,
    altName: string,
    operationalStatus: string,
    siteType: string, 
    address: string, 
    postcode: string,  
    elr: number,
    mileage: number,
    latitude: number,
    longitude: number,
    photos: string[] | null,
    comments: string,
    lastModified: number,
    created: number
}

export interface IBlock {
    blockId: number, 
    name: string, 
    altName: string,
    operationalStatus: string,
    elr: number,
    mileage: string, 
    siteId: string,
    lastModified: number,
    created: number
}

export interface IOther {
    id: number,
    userSearchIndex: any,
}

export interface IImage {
    id?: number,
    imageString: string,
}

export const db = new LinesideDatabase();
